import { PaymentCardType } from '@shinetools/pricing-plan-library';

import { PricingPlan } from '__generated__/GQL';
import { toMajorUnits } from 'helpers/amount';

import { PhysicalOrderFlowConfig } from './hooks/usePhysicalCardOrderFlowContext';
import { PhysicalCardOrderFlowQueryData } from './hooks/usePhysicalCardOrderFlowQuery';

export function mapQueryResultToFlowConfig(
  data: PhysicalCardOrderFlowQueryData,
  plan: Pick<PricingPlan, 'paymentCard'>,
): PhysicalOrderFlowConfig {
  const {
    basicCardMonthlyFee,
    newBasicCardPrice,
    newPremiumCardPrice,
    premiumCardMonthlyFee,
    viewer: {
      company: {
        bankAccount: { bankAccountId, nextBalance: nextBalanceInMinorUnits },
        profile: { legalForm, ...professionalAddress },
      },
      profile: { firstName, lastName, ...personalAddress },
    },
  } = data;

  const canOrderPremiumCard =
    plan.paymentCard.type === PaymentCardType.BusinessWorldDebitCard;

  return {
    bankAccount: {
      bankAccountId,
      nextBalance: toMajorUnits(nextBalanceInMinorUnits),
    },
    canSelectDeliveryAddress: !['EI', 'EIRL'].includes(legalForm),
    cardType: canOrderPremiumCard ? 'premium' : 'basic',
    coordinates: {
      fullName: `${firstName} ${lastName}`,
      personalAddress,
      professionalAddress,
    },
    pricingWithoutVAT: {
      cardPrice: canOrderPremiumCard
        ? newPremiumCardPrice.priceWithoutVAT
        : newBasicCardPrice.priceWithoutVAT,
      monthlyFee: canOrderPremiumCard
        ? premiumCardMonthlyFee.priceWithoutVAT
        : basicCardMonthlyFee.priceWithoutVAT,
    },
  };
}
